import {
  COMMON_PATHS,
  findLayersOrLayerAssets,
  getPath,
  IInteractiveModJSExpression,
} from "@blings/blings-player";
import { ModsPanelCompProps } from "../../ModsPanel";
import { AddInteractiveHOC } from "./InteractiveFormHOC";
import { JsEditor } from "../../../../components/Editor/JsEditor";
import { Col, Input, Row } from "antd";
import { useMst } from "../../../../stores/main";
import MainCTAButton from "../../../MainCTA/MainCTAButton";
import { InfoTooltip } from "../../../../BaseComps/InfoTooltip";
import { useEffect } from "react";
import { sharedInputAllowClear } from "../../../antd-extensions/selectClearIcon";

export const useDefaultFunctionForInteractionExpression = (
  isControlDeprecated: boolean = false
) => `(data, ${
  isControlDeprecated ? "_" : "liveData"
}, event, element, player) => {
  console.log("clicked") 
}`;

function RenderActionForm(
  props: ModsPanelCompProps<IInteractiveModJSExpression>
) {
  const { platformStore } = useMst();
  const { change, json, onChange, index } = props;
  const defaultString = useDefaultFunctionForInteractionExpression(
    platformStore.isControlDeprecated
  );

  useEffect(() => {
    if (change.ctaName == null) {
      const layers = findLayersOrLayerAssets({
        assetId: change.assetId,
        layerName: change.layerName,
        layerUid: change.layerUid,
        jsonVid: json,
        additionals: change.additionals,
      });
      const layer =
        layers?.length &&
        layers.find((layer) => getPath(layer, COMMON_PATHS.TEXT_IN_LAYER));
      if (layer) {
        const text = getPath(layer, COMMON_PATHS.TEXT_IN_LAYER);
        text && onChange(index, "ctaName", text);
      }
    }
  }, [
    change.ctaName,
    change.assetId,
    change.layerName,
    change.layerUid,
    change.additionals,
    json,
    onChange,
    index,
  ]);

  return (
    <>
      <Row>
        <Col style={{ width: "100%" }}>
          <span style={{ color: "#6E7079", lineHeight: "22px" }}>
            Name this button (Required for analytics)
          </span>
          <InfoTooltip
            style={{ marginLeft: "5px" }}
            info="This name is used to track how many viewers clicked on the button."
          />
          <Input
            style={{ width: "100%", marginTop: "4px" }}
            id="connector-cta-name"
            value={props.change.ctaName}
            // eslint-disable-next-line no-template-curly-in-string
            placeholder="Name this button"
            onChange={(e) =>
              props.onChange(props.index, ["ctaName"], [e.target.value])
            }
            allowClear={sharedInputAllowClear}
          />
        </Col>
      </Row>
      <JsEditor
        defaultValue={
          props.change.functionString === ""
            ? defaultString
            : props.change.functionString
        }
        onChange={(e: any) => props.onChange(props.index, "functionString", e)}
        runtimeContext="interactiveExpression"
        tooltipText="This function will run every time the user interacts with the layer\s"
      />
      <MainCTAButton
        change={props.change}
        onChange={props.onChange}
        index={props.index}
      />
    </>
  );
}

export function AddInteractionJsExpressionForm(
  props: ModsPanelCompProps<IInteractiveModJSExpression>
) {
  return (
    <AddInteractiveHOC<IInteractiveModJSExpression>
      {...props}
      renderSpecificInteractive={RenderActionForm}
    />
  );
}
